import type { IconProps } from "../types";

export const Layers = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 2 2 6.99 12 11.99 22 6.99 Z" />
    <path d="M2 12 12 17 22 12" />
    <path d="M2 17 12 22 22 17" />
  </svg>
);
